const __DEV__ = process.env.NODE_ENV !== 'production'; // eslint-disable-line no-underscore-dangle

module.exports = {
  out: console,
  deprecate(...args) {
    if (__DEV__) {
      this.out.warn('DeprecationWarning:', ...args);
    }
  },
  debug(...args) {
    if (__DEV__) {
      this.out.debug(...args);
    }
  },
  error(...args) {
    if (__DEV__) {
      this.out.error(...args);
    }
  },
  info(...args) {
    if (__DEV__) {
      this.out.info(...args);
    }
  },
  log(...args) {
    if (__DEV__) {
      this.out.log(...args);
    }
  },
  warn(...args) {
    if (__DEV__) {
      this.out.warn(...args);
    }
  },
  table(...args) {
    if (__DEV__) {
      this.out.table(...args);
    }
  },
  trace(...args) {
    if (__DEV__) {
      this.out.trace(...args);
    }
  },
  group(...args) {
    if (__DEV__) {
      this.out.group(...args);
    }
  },
  groupCollapsed(...args) {
    if (__DEV__) {
      this.out.groupCollapsed(...args);
    }
  },
  groupEnd(...args) {
    if (__DEV__) {
      this.out.groupEnd(...args);
    }
  },
  clear(...args) {
    if (__DEV__) {
      this.out.clear(...args);
    }
  },
  count(...args) {
    if (__DEV__) {
      this.out.count(...args);
    }
  },
  assert(...args) {
    if (__DEV__) {
      this.out.assert(...args);
    }
  },
  time(...args) {
    if (__DEV__) {
      this.out.time(...args);
    }
  },
  timeEnd(...args) {
    if (__DEV__) {
      this.out.timeEnd(...args);
    }
  },
};
